"use client";

import dynamic from "next/dynamic";
import { useEffect, useState } from "react";

const ACTIVATION_EVENTS = ["pointerdown", "keydown", "scroll", "touchstart"] as const;
const FALLBACK_DELAY_MS = 15_000;

const GtagScript = dynamic(() => import("@/components/GtagScript"), { ssr: false });
const ClarityScript = dynamic(() => import("@/components/ClarityScript"), { ssr: false });
const RedditPixelScript = dynamic(() => import("@/components/RedditPixelScript"), { ssr: false });

const DeferredAnalytics = () => {
  const [activated, setActivated] = useState(false);

  useEffect(() => {
    const listenerOptions: AddEventListenerOptions = { passive: true };
    let activationComplete = false;

    const cleanup = () => {
      window.clearTimeout(fallbackTimer);
      ACTIVATION_EVENTS.forEach((event) =>
        window.removeEventListener(event, activate, listenerOptions)
      );
    };

    const activate = () => {
      if (activationComplete) return;

      activationComplete = true;
      cleanup();
      void import("@/components/OneSignalScript").then(({ requestOneSignalLoad }) =>
        requestOneSignalLoad()
      );
      setActivated(true);
    };

    const fallbackTimer = window.setTimeout(activate, FALLBACK_DELAY_MS);

    ACTIVATION_EVENTS.forEach((event) => window.addEventListener(event, activate, listenerOptions));

    return cleanup;
  }, []);

  if (!activated) return null;

  return (
    <>
      <GtagScript />
      <ClarityScript />
      <RedditPixelScript />
    </>
  );
};

export default DeferredAnalytics;
